module.exports = __webpack_public_path__ + "7f92fd6bc3de49d69654cd47d2eed3f2.pdf";